<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button, Input } from "view-design";
import Vue from "vue";
import Info from "../info.vue";
import Repair from "../repair.vue";
import EditPro from "../editProcessing.vue";
import Track from "../track.vue";
import timeIcon from "../../../assets/img/timeIcon.png";
export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    EditPro,
  },
  data() {
    return {
      menu_name: "",
      makeMain: "",
      table: {
        mname: "work",
        key: "id",
        url: {
          del: "/admin/system/work/del",
        },
      },
      actions: [
        // {
        //   label: '新增',
        //   icon: 'md-add',
        //   onClick: this.toAdd,
        //   auth: '',
        // },
        // {
        //   label: '导入',
        //   icon: 'md-add',
        //   onClick: this.toImport,
        //   auth: '',
        // },
        // {
        //   label: '下载模板',
        //   icon: '',
        //   onClick: this.toDownload,
        //   auth: '',
        // },
      ],
      menus: [
        {
          label: "待处理",
          name: "workOrder_list",
          auth: "system/workOrder/index",
          badge: { mname: "workstate", scene: "1", url: "/admin/system/work/state" },
        },
        {
          label: "处理中",
          name: "processing_list",
          auth: "system/processing/index",
          badge: { mname: "workstate", scene: "2", url: "/admin/system/work/state" },
        },
        {
          label: "挂起中",
          name: "workPending_list",
        },
        {
          label: "已完成",
          name: "completed_list",
          auth: "system/completed/index",
          // badge: { mname: "workstate", scene: "3" },
        },
        {
          label: "抢单池",
          name: "workOrder_seize",
          badge: { mname: "workstate", scene: "4", url: "/admin/system/work/state" },
        },
        {
          label: "回收站",
          name: "workOrder_recyle",
        },
      ],
      query: {
        state: 2,
      },
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "repairTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修人",
          KeyEnter: this.search,
          name: "repairBy",
          value: "",
          type: "input",
        },
        // {
        //   label: "资产",
        //   name: "facilityNo",
        //   value: "",
        //   KeyEnter: this.search,
        //   type: "select",
        //   dropList: [],
        // },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "处理人",
          KeyEnter: this.search,
          name: "maintainerName",
          value: "",
          type: "input",
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
        // { label: '资产名称', name: 'facilityName', value: '', type: 'input' },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "报修时间",
          width: 180,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "问题描述",
          key: "descr",
          minWidth: 350,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            return h(
              "div",
              {
                style: `display: flex;
  align-items: center;`,
              },
              [
                h(
                  "div",
                  {
                    style:
                      this.workOrderTime(text, 1) > 30
                        ? `padding: 2px 5px;
                           border-radius: 5px;
                           margin-right: 5px;
                           display: flex;
                           align-items: center;
                           background-color: #f6c6ad;
                           color: #ff0000;
                          `
                        : `padding: 2px 5px;
                           border-radius: 5px;
                           margin-right: 5px;
                           display: flex;
                           align-items: center;
                           background-color: #c2f1c8;
                           color: rgb(0 149 20);`,
                  },
                  [
                    h("img", {
                      style: `width: 20px;
                              height: 20px;
                              margin-right: 3px;`,
                      attrs: { src: timeIcon },
                    }),
                    h(
                      "div",
                      {
                        style: `height: 20px;
                                line-height: 20px;
                                white-space: nowrap;`,
                      },
                      this.workOrderTime(text, 2)
                    ),
                  ]
                ),
                h("div", { class: "descr_right" }, this.workOrderTime(text, 3)),
              ]
            );
          },
        },
        {
          title: "所在科室",
          key: "department",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          width: 120,
          align: "center",
          key: "repairBy",
          // sortable: true,
          tooltip: "true",
        },
       /*  {
          title: "报修来源",
          key: "repairSource",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource === 1 && row.isFastOrder === 0
                ? "扫码报修"
                : row.repairSource === 1 && row.isFastOrder === 1
                ? "移动报修"
                : row.repairSource === 4
                ? row.repairPhone
                  ? row.repairPhone
                  : "电话报修"
                : row.repairSource === 5 && row.isFastOrder === 0
                ? "用户PC普通"
                : row.repairSource === 5 && row.isFastOrder === 1
                ? "用户PC快速"
                : row.repairSource === 3 && row.isFastOrder === 0
                ? "后台设备报修"
                : row.repairSource === 3 && row.isFastOrder === 1
                ? "后台科室报修"
                : row.repairSource === 2
                ? "维修员"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        }, */
        {
          title: "处理人",
          key: "maintainerName",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [{ name: "auth", value: "system/processing/repair" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    marginLeft: "5px",
                    marginRight: "5px",
                    color: "#4991ff",
                  }}
                >
                  写记录
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [{ name: "auth", value: "admin/processing/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  详情
                </Button>
              );
            },
            "del",
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [{ name: "auth", value: "admin/processing/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.onPending(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  挂起
                </Button>
              );
            },
          ],
        },
      ],
      suspensionContent: "",
    };
  },

  created() {
    // this.loadLevelData();
    this.loadLevelDatas();
    this.loaddeskData();
    // this.loadFiltersFieldDrop('community', 'community_id')
  },
  methods: {
    onPending(row) {
      this.$Modal.confirm({
        width: "600px",
        closable: "true",
        draggable: "true",
        render: () => {
          return (
            <div>
              <div style="display: flex; align-items: baseline;margin-top:30px">
                <p style="width:100px;">挂起原因:</p>
                <Input
                  v-model={this.suspensionContent}
                  placeholder="请填写挂起原因"
                  on-change={(event) => {
                    this.suspensionContent = event.target.value;
                  }}
                ></Input>
              </div>
              <div style="margin-top:20px">
                <Button
                  type="default"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
                <Button
                  style="margin-left:20px"
                  type="primary"
                  onClick={() => {
                    this.onPendingget(row.id, this.suspensionContent);
                  }}
                >
                  确认
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    async onPendingget(id, text) {
      if (text == "") {
        $utils.toast.error("请填写挂起原因!");
        return;
      }
      let q = {
        workId: id,
        suspensionContent: text,
      };
      let res = await $utils.api.load("/admin/system/work/suspensionWork", q, "post");
      if (res.code == 200) {
        $utils.toast.success(res.message);
        this.$Modal.remove();
        this.search();
      }
    },
    workOrderTime(e, type) {
      if (type == 1) {
        let timeA = Number(e.split("]")[0]);
        return timeA;
      } else if (type == 2) {
        let timeB = Number(e.split("]")[0]);
        let returnTime = "";
        if (timeB >= 60 * 24) {
          let d = parseInt(timeB / (60 * 24));
          let h = parseInt((timeB % (60 * 24)) / 60);
          let m = (timeB % (60 * 24)) % 60;
          returnTime = `${d}天${h}时${m}分`;
        } else if (60 * 24 >= timeB && timeB >= 60) {
          let ha = parseInt(timeB / 60);
          let ma = timeB % 60;
          returnTime = `${ha}时${ma}分`;
        } else {
          returnTime = `${timeB}分`;
        }
        return returnTime;
      } else if (type == 3) {
        let timeC = e.split("]")[1];
        return timeC;
      }
    },
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api.load(`/admin/system/desk/selectList`, q, "get").then((res) => {
            const list = res.rows.map((item) => {
              return {
                value: item.id,
                name: item.deskName,
              };
            });
            // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = list;
              }
            }
          });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load(`/admin/system/desk/selectList/?isParent=${"0"}`, q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.deskName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "deskId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNo") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "processing_add", query: { action: "add" } });
    },
    toRepair(row) {
      this.$Modal.success({
        closable: true,
        title: "送修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Repair style={{ margin: "0", color: "#19be6b" }} workId={row.id}></Repair>
          );
        },
      });
    },
    toEdit(row) {
      this.$Modal.success({
        closable: true,
        title: "填写记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <EditPro
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
              typeId={row.typeId}
            ></EditPro>
          );
        },
      });
    },
    toTrack(row) {
      this.$Modal.success({
        closable: true,
        title: "维修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Track style={{ margin: "0", color: "#19be6b" }} workId={row.id}></Track>
          );
        },
      });
    },
    toRecycle() {
      $utils.url.push({
        name: "workOrder_recyle",
      });
    },
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },
    toImport() {},
    toDownload() {},
  },
};
</script>
<style scoped lang="less"></style>
